import { shallowEqual, useSelector } from 'react-redux';
import { getSelfLock } from '../selectors';

export const useUserSelfLock = () => ({
  selfLock: useSelector(getSelfLock, shallowEqual),
});
